<div
  class="left flex-grow-1"
  #left
>
  <app-blockly-tab></app-blockly-tab>
</div>

@if (this.fullscreenLayout.botIsVisible) {
<div
  class="resizer d-flex"
  #resizer
  (mousedown)="startResize($event)"
>&nbsp;</div>
}
@if (this.fullscreenLayout.botIsVisible) {
<div
  class="right"
  #right
>
  <div class="text-end row mt-1 mb-1  ">
    <div class="col-auto pe-0">
      <button
        class="btn btn-sm btn-outline-primary border-0"
        (click)="this.resetBot()"
      >
        <i class="ri-reset-right-fill"></i>
      </button>
    </div>
    <div class="col-auto ">
      <p-select
        [options]="[...botTypes]"
        [(ngModel)]="selectedBotType"
        size="small"
        appendTo="body"
      >
        <ng-template
          pTemplate="selectedItem"
          let-value
        >
          {{ botTypeToLabel.get(value) }}
        </ng-template>
        <ng-template
          pTemplate="item"
          let-value
        >
          {{ botTypeToLabel.get(value) }}
        </ng-template>
      </p-select>
    </div>
    <div class="col"></div>
    @if (this.fullscreenLayout.botIsVisible) {
    <div class="col text-end d-flex align-items-center justify-content-end">
      <div
        class="btn btn-outline-primary btn-sm  border-0"
        (click)="this.fullscreenLayout.toggleBot()"
      >🤖</div>
      <!-- <app-bot-open-dropdown [smallButton]="true"></app-bot-open-dropdown> -->
    </div>
    }
    <!--
      <div class="col-auto">
        <div
          class="btn btn-outline-secondary btn-sm border-0"
          (click)="this.fullscreenLayout.toggleBot()"
        >🤖</div>
      </div>
      -->
  </div>
  <iframe
    id="botframe"
    style="height: 100%;display: block; border-radius: 20px; margin-right:3px"
    title="Chatbot"
    [src]='"/" + this.langService.getLanguage()+"/bot/"+this.rss.botConfig._id + this.selectedBotType| safe'
    width="100%"
    height="100%"
    frameborder="1"
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-modals allow-downloads allow-storage-access-by-user-activation"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; microphone; download *; fullscreen; camera; speaker; geolocation"
    referrerpolicy="strict-origin-when-cross-origin"
  ></iframe>
</div>
}